// @flow
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

// Components
import ErrorPanel from './ErrorPanel';

// Selectors
import { getShowStatusButton } from 'store/reducers/appointment/selfCheckIn/selectors';
import { getConfirmationKey } from 'store/reducers/appointment/selectors';
import { getWebkey, getQueryParam } from 'store/reducers/queryParams/selectors';
import { getStatusTrackerURL } from 'store/reducers/selfCheckIn/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';
import {
  getDealerContact,
  getDealerCountryCode
} from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => ({
  showStatusButton: getShowStatusButton(state),
  reservationId: +getQueryParam('reservationId')(state),
  confirmationKey: getConfirmationKey(state),
  webKey: getWebkey(state),
  statusTrackerURL: getStatusTrackerURL(state),
  dealerContact: getDealerContact(state),
  dealerCountryCode: getDealerCountryCode(state),
  dealerLocale: getLocaleCode(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(ErrorPanel);



// WEBPACK FOOTER //
// ./src/components/atoms/ErrorPanel/ErrorPanelContainer.js